<template>
  <button
    class="btn btn-repeat-strengths-mapping mt-1"
    @click="onCreateNewSoloClick"
    :disabled="isButtonDisabled"
    data-test="create-new-solo-button"
  >
    Create new solo report
  </button>
</template>
<script setup lang="ts">
import axios from "axios";
import { ref } from "vue";

const isButtonDisabled = ref(false);
const onCreateNewSoloClick = async () => {
  isButtonDisabled.value = true;
  const { request } = await axios.post("/review/reviewyourselfagain");
  if (request?.responseURL.length > 0) {
    window.location.href = request.responseURL;
  }
};
</script>

<style scoped lang="less">
.mt-1 {
  margin-top: 1rem;
}
</style>
